import React from "react";
import { ShieldCheck, Award, MapPin, ThumbsUp, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const trustBadges = [{
  icon: Award,
  title: "FDACS Licensed",
  description: "State certified professionals"
}, {
  icon: ShieldCheck,
  title: "Fully Insured",
  description: "Complete property protection"
}, {
  icon: MapPin,
  title: "Local Knowledge",
  description: "Serving North Fort Myers"
}, {
  icon: ThumbsUp,
  title: "Highly Trusted",
  description: "By local residents"
}];
export default function NorthFortMyersLocalServiceProvider() {
  return <section id="north-fort-myers-local-service-provider" className="py-16 md:py-24 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="flex flex-col items-start space-y-6">
            <Badge variant="secondary" className="px-3 py-1 text-sm">
              Local Service Provider
            </Badge>
            
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-foreground">
              Your Trusted <span className="text-primary">North Fort Myers</span> Pest Control Experts
            </h2>
            
            <div className="space-y-4 text-lg text-muted-foreground">
              <p>
                As a dedicated local service provider, we deeply understand the unique climate and specific pests that affect homes and businesses in the <strong>North Fort Myers</strong> area. The geography of <strong>North Fort Myers</strong> is defined by its proximity to the Caloosahatchee River and an extensive network of canals that create a humid, often boggy environment perfect for pest breeding. From the historic charm of the Old Bridge Village to the sprawling residential landscapes of <strong>North Fort Myers</strong> neighborhoods like Pine Island Road corridors and the riverside communities of San Carlos, each area presents its own set of challenges. The lush, tropical vegetation that makes <strong>North Fort Myers</strong> so beautiful also provides the ideal canopy for invasive species. Our targeted treatments are designed specifically for Southwest Florida's environment, ensuring that whether you live near the busy commercial hubs or the quiet, wooded outskirts of <strong>North Fort Myers</strong>, your property remains a fortress against unwanted intruders. We have spent years mapping the pest patterns across <strong>North Fort Myers</strong>, allowing us to provide a level of localized expertise that national chains simply cannot match.
              </p>
              <p>
                We are fully insured and FDACS licensed, proudly serving our community with the highest standards of safety and efficacy. In <strong>North Fort Myers</strong>, the pest pressure is relentless; the high water table and sandy soils create a perfect storm for subterranean termite activity, which can go unnoticed until significant structural damage has occurred. Furthermore, the standing water often found in the drainage systems of <strong>North Fort Myers</strong> leads to intense mosquito populations that require specialized, consistent management. We also see a high prevalence of fire ants in the sandy patches of <strong>North Fort Myers</strong> lawns, posing a threat to families and pets. Because <strong>North Fort Myers</strong> experiences such high humidity and frequent seasonal rains, standard "one-size-fits-all" treatments often wash away or lose potency quickly. Our team utilizes advanced, weather-resistant formulations specifically chosen for the <strong>North Fort Myers</strong> climate. Over the years, we have become the go-to choice, trusted by countless <strong>North Fort Myers</strong> residents to keep their properties safe, healthy, and completely pest-free through every season of the year. Choosing a local <strong>North Fort Myers</strong> expert means choosing someone who knows exactly what is crawling in your backyard before they even step out of the truck.
              </p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="font-default text-base">
                <Link to="/ContactPage">
                  Get Your Free Local Quote
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative">
            {}
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-xl border border-border/50">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/north_fort_myers_pest_truck.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/north_fort_myers_pest_truck.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1659158/img/north_fort_myers_pest_truck.png-wvc-sizes" alt="Professional pest control service vehicle in North Fort Myers" className="object-cover w-full h-full" loading="lazy" />
              </AspectRatio>
            </div>

            {}
            <div className="absolute -top-6 -right-6 w-64 h-64 bg-primary/10 rounded-lg blur-3xl -z-10"></div>
            <div className="absolute -bottom-8 -left-8 w-72 h-72 bg-secondary/10 rounded-lg blur-3xl -z-10"></div>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8 relative z-20">
              {trustBadges.map((badge, i) => {
              const Icon = badge.icon;
              return <Card key={i} data-index={i} className="bg-card/95 backdrop-blur-sm border-border/50 shadow-md hover:shadow-lg transition-shadow duration-300">
                    <CardContent className="p-4 flex items-start space-x-4">
                      <div className="bg-primary/10 p-2.5 rounded-lg shrink-0">
                        <Icon className="size-6 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-default font-semibold text-foreground text-sm md:text-base">
                          {badge.title}
                        </h3>
                        <p className="text-xs md:text-sm text-muted-foreground mt-0.5">
                          {badge.description}
                        </p>
                      </div>
                    </CardContent>
                  </Card>;
            })}
            </div>
          </div>

        </div>
      </div>
    </section>;
}